$( document ).ready(function() {
  $('br').attr('aria-hidden','true');
  $('a[href="/pages/about-us"]:contains("LEARN MORE")').attr('aria-label', 'LEARN MORE about us');  
  $('.warn a').attr('aria-label','Email Address:support@brooklyncandlestudio.com, This Link Will open in a new tab');
  $('.prose.text-center h1:empty, .prose.text-center h2:empty, .prose.text-center h3:empty, .prose.text-center h4:empty, .prose.text-center h5:empty, .prose.text-center h6:empty').remove();
  $('#contact_form button').attr('aria-label', 'Send message button. When you click on this button, the page will be refreshed, and focus will go to the top of the page.');
  
});


// $('.prose.text-center h3').replaceWith(function() {
//   return $('<span>', { html: $(this).html() });
// });

// $('.prose h3').replaceWith(function() {
//   return $('<span>', { html: $(this).html() });
// });

document.addEventListener("DOMContentLoaded", function() {
  var thirdPartyLinks = document.querySelectorAll('p a, .footer__block.footer__block--links a');

  // Loop through each link
  thirdPartyLinks.forEach(function(link) {
      // Check if the link leads to a third-party website
      if (isThirdParty(link.href)) {
          // Add the target="_blank" attribute
          link.setAttribute('target', '_blank');

          // Add the text indicating it will open in a new tab
          var existingText = link.textContent.trim();
          var newText = existingText + ', This Link will open in a new tab';
          link.setAttribute('aria-label', newText);
      }
  });

  // Function to check if a link is from a third-party website
  function isThirdParty(url) {
      return !url.includes('brooklyncandlestudio.com');
  }
});


$(document).ready(function () {
    var existCondition = setInterval(function () {
        if ($('a').length) {
            clearInterval(existCondition);
            runMyFunctionrmvtb();
        }
    }, 200);

    function runMyFunctionrmvtb() {
        $('a').each(function() {
            // Check if the <a> tag contains any text or non-empty child elements
            if ($(this).html().trim() === '' || $(this).children().length === 0 && $(this).text().trim() === '') {
                $(this).remove();
            }
        });
    }
        $('a[href="https://brooklyncandlestudio.com/products/deluxe-candle-of-the-month-subscription?selling_plan=3503521895"]').each(function() {
            if ($(this).find('media-grid').is(':empty')) {
                $(this).remove();
            }
        });
});
$(document).ready(function() {
    $('.prose.text-center h5').each(function() {
      var $this = $(this);
      var newElement = $('<p></p>').addClass('hf-to-p').html($this.html());
      $this.replaceWith(newElement);
    });
  });
  

//   // When the user scrolls down 20px from the top of the document, show the button
// window.onscroll = function() {
//     scrollFunction();
//   };
  
//   function scrollFunction() {
//     if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
//       document.getElementById("back-to-top").style.display = "block";
//     } else {
//       document.getElementById("back-to-top").style.display = "none";
//     }
//   }
  
//   // When the user clicks on the button, scroll to the top of the document
//   document.getElementById("back-to-top").onclick = function() {
//     scrollToTop();
//   };
  
//   function scrollToTop() {
//     const scrollStep = -window.scrollY / (500 / 15);
//     const scrollInterval = setInterval(function() {
//       if (window.scrollY !== 0) {
//         window.scrollBy(0, scrollStep);
//       } else {
//         clearInterval(scrollInterval);
//       }
//     }, 15);
//   }

document.addEventListener('DOMContentLoaded', function() {
  var backToTopButton = document.getElementById('back-to-top');
  
  window.addEventListener('scroll', function() {
      if (window.scrollY > 300) {
          backToTopButton.style.display = 'block';
      } else {
          backToTopButton.style.display = 'none';
      }
  });
  
  backToTopButton.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // Set focus to the top of the page after scrolling
      setTimeout(function() {
          document.getElementById('go-top1').focus(); // Ensure this element exists
      }, 600); // Adjust the timeout duration to match the scroll duration
  });
});


  document.addEventListener('DOMContentLoaded', function() {
    var carousel = document.getElementById('{{ carousel_id }}');
    var prevButton = document.querySelector('.carousel-control.prev');
    var nextButton = document.querySelector('.carousel-control.next');

      prevButton && prevButton.addEventListener('click', function() {
      carousel.previous();
    });

    nextButton && nextButton.addEventListener('click', function() {
      carousel.next();
    });
  });

  $(document).ready(function() {
    $('h4').each(function() {
        if ($(this).is(':empty')) {
            $(this).remove();
        }
    });
});

$(document).ready(function() {
  $('.table-scroller table').attr('role','presentation');
});

$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('.gt_redirectpopup_1677728147506_image').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb01();
      }
  }, 200);

  function runMyFunctionrmvtb01() {
    $('.gt_redirectpopup_1677728147506_image').attr('alt', 'A hand lighting a candle labeled Santorini next to a vase with pink roses on a light-colored wooden surface.');
  }
});

$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('img.gt_redirectpopup_1677728147506_logo').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb02();
      }
  }, 200);

  function runMyFunctionrmvtb02() {
    $('img.gt_redirectpopup_1677728147506_logo').attr('alt', 'Brooklyn Candle Studio logo');
  }
});

$(document).ready(function() {
  var headingText = $('.blg .h2').text();
  var buttonText = $('.blg .button').text();
  var ariaLabel = buttonText + ' about ' + headingText;
  $('.blg .button').attr('aria-label', ariaLabel);
});


$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('.accordion__content.prose a').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb03();
      }
  }, 200);

  function runMyFunctionrmvtb03() {
    $('.accordion__content.prose a').each(function() {
      if ($(this).children().length === 0 || ($(this).children().length === 1 && $(this).children('br').length === 1)) {
          $(this).remove();
      }
    });
  }
});

$(document).ready(function(){
  $('.cc-list .button').replaceWith(function(){
    return $('<span />', {
      html: $(this).html(),
      class: $(this).attr('class'),
      type: $(this).attr('type')  // This will add the type attribute, though it's not standard for span
    });
  });
});

$(document).ready(function(){
  $('.prose.prose--tight.place-self-start-center.text-center .button').replaceWith(function(){
    return $('<span />', {
      html: $(this).html(),
      class: $(this).attr('class'),
      type: $(this).attr('type')  // This will add the type attribute, though it's not standard for span
    });
  });
});

$(document).ready(function(){
  $('.blg .button').replaceWith(function(){
    return $('<span />', {
      html: $(this).html(),
      class: $(this).attr('class'),
      type: $(this).attr('type')  // This will add the type attribute, though it's not standard for span
    });
  });
});


// $(document).ready(function () {
//   var existCondition = setInterval(function () {
//       if ($('#sgp a').length) {
//           clearInterval(existCondition);
//           runMyFunctionrmvtb04();
//       }
//   }, 200);

//   function runMyFunctionrmvtb04() {
//     $('#sgp a').each(function() {
//       if ($(this).children().length === 0 || ($(this).children().length === 1 && $(this).children('br').length === 1)) {
//           $(this).remove();
//       }
//     });
//   
// });

$(document).ready(function() {
  $('.accordion__content.prose a').each(function() {
    // Check if the anchor tag is effectively empty (ignores text, looks for child elements)
    if ($(this).text().trim() === "" && $(this).children().length > 0) {
      // Replace the <a> with its inner content
      $(this).replaceWith($(this).contents());
    }
  });
});


$(document).ready(function() {
  $('div#sgp a').each(function() {
    // Check if the anchor tag is effectively empty (ignores text, looks for child elements)
    if ($(this).text().trim() === "" && $(this).children().length > 0) {
      // Replace the <a> with its inner content
      $(this).replaceWith($(this).contents());
    }
  });
});



$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('.js-seo-text-trigger').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb138();
      }
  }, 200);

  function runMyFunctionrmvtb138() {
    $('.js-seo-text-trigger').each(function() {
      // Set the initial aria-label based on the content of the span
      var moreText = $(this).data('more');
      var lessText = $(this).data('less');
      var currentText = $(this).find('span').text();
      
      if (currentText === moreText) {
        $(this).attr('aria-label', 'Click here to ' + moreText);
      } else if (currentText === lessText) {
        $(this).attr('aria-label', 'Click here to ' + lessText);
      }
      
      // Add click event to update aria-label when the link is clicked
      $(this).on('click', function(e) {
        e.preventDefault(); // Prevent the default action for demonstration
        
        // Toggle the span text
        var span = $(this).find('span');
        var newText = (span.text() === moreText) ? lessText : moreText;
        span.text(newText);
  
        // Update the aria-label based on the new text
        $(this).attr('aria-label', 'Click here to ' + newText);
      });
    });
  }
});

$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('.qab_slide_message a').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb137();
      }
  }, 200);

  function runMyFunctionrmvtb137() {
    $('.qab_slide_message a').each(function() {
      // Check if the anchor tag is effectively empty (ignores text, looks for child elements)
      if ($(this).text().trim() === "" && $(this).children().length > 0) {
        // Replace the <a> with its inner content
        $(this).replaceWith($(this).contents());
      }
    });
  }
});

